"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.style = void 0;
const avatars_1 = require("@dicebear/avatars");
const paths = __importStar(require("./paths"));
const colors = __importStar(require("./colors"));
const schema_1 = require("./schema");
exports.style = {
    meta: {
        title: 'Avatar Illustration System',
        creator: 'Micah Lanier',
        contributor: 'Florian Körner',
        source: 'https://www.figma.com/community/file/829741575478342595',
        license: {
            name: 'CC BY 4.0',
            url: 'https://creativecommons.org/licenses/by/4.0/',
        },
    },
    schema: schema_1.schema,
    create: ({ prng, options }) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const pickColor = (values, filter = []) => {
            let result = values.map((val) => colors[val] || val);
            // If only one color was given, that color was explicitly selected. Then do not perform any filtering.
            if (values.length > 1) {
                result = result.filter((val) => false === filter.includes(val));
            }
            if (result.length === 0) {
                result.push('transparent');
            }
            return prng.pick(result);
        };
        const pickPath = (paths, values = []) => {
            const key = prng.pick(values);
            return {
                path: paths[key],
                key,
            };
        };
        const baseColor = pickColor((_a = options.baseColor) !== null && _a !== void 0 ? _a : []);
        const hairColor = pickColor((_b = options.hairColor) !== null && _b !== void 0 ? _b : [], [baseColor]);
        const shirtColor = pickColor((_c = options.shirtColor) !== null && _c !== void 0 ? _c : [], [baseColor]);
        const earringColor = pickColor((_d = options.earringColor) !== null && _d !== void 0 ? _d : [], [baseColor, hairColor]);
        const glassesColor = pickColor((_e = options.glassesColor) !== null && _e !== void 0 ? _e : [], [baseColor, hairColor]);
        const eyeShadowColor = pickColor((_f = options.eyeShadowColor) !== null && _f !== void 0 ? _f : [], [baseColor, glassesColor]);
        const eyebrowColor = pickColor((_g = options.eyebrowColor) !== null && _g !== void 0 ? _g : [], [baseColor, glassesColor, eyeShadowColor]);
        const facialHairColor = pickColor((_h = options.facialHairColor) !== null && _h !== void 0 ? _h : [], [baseColor]);
        const { path: earringsPath } = pickPath(paths.earrings, options.earrings);
        const { path: glassesPath } = pickPath(paths.glasses, options.glasses);
        const { path: hairPath } = pickPath(paths.hair, options.hair);
        const { path: facialHairPath, key: facialHairPathKey } = pickPath(paths.facialHair, options.facialHair);
        const shirt = pickPath(paths.shirt, options.shirt).path;
        const earrings = prng.bool(options.earringsProbability) && earringsPath;
        const ears = pickPath(paths.ears, options.ears).path;
        const nose = pickPath(paths.nose, options.nose).path;
        const glasses = prng.bool(options.glassesProbability) && glassesPath;
        const eyes = pickPath(paths.eyes, options.eyes).path;
        const eyebrows = pickPath(paths.eyebrows, options.eyebrows).path;
        const mouth = pickPath(paths.mouth, options.mouth).path;
        const hair = prng.bool(options.hairProbability) && hairPath;
        const facialHair = prng.bool(options.facialHairProbability) && facialHairPath;
        const base = pickPath(paths.base, options.base).path;
        const isBlackFacialHairColor = facialHairColor.match(/^#0+$/);
        const mouthColor = facialHair && facialHairPathKey === 'beard' && isBlackFacialHairColor ? '#434343' : '#000';
        return {
            attributes: {
                viewBox: '0 0 360 360',
                fill: 'none',
            },
            body: `
        ${base ? avatars_1.utils.svg.createGroup({ children: base(baseColor), x: 90, y: 43 }) : ''}
        ${facialHair ? avatars_1.utils.svg.createGroup({ children: facialHair(facialHairColor), x: 124, y: 145.3 }) : ''}
        ${mouth ? avatars_1.utils.svg.createGroup({ children: mouth(mouthColor), x: 180, y: 203 }) : ''}
        ${eyebrows ? avatars_1.utils.svg.createGroup({ children: eyebrows(eyebrowColor), x: 120, y: 122 }) : ''}
        ${hair ? avatars_1.utils.svg.createGroup({ children: hair(hairColor), x: 59, y: 31 }) : ''}
        ${eyes ? avatars_1.utils.svg.createGroup({ children: eyes(eyeShadowColor), x: 152, y: 139 }) : ''}
        ${glasses ? avatars_1.utils.svg.createGroup({ children: glasses(glassesColor), x: 112, y: 131 }) : ''}
        ${nose ? avatars_1.utils.svg.createGroup({ children: nose('#000'), x: 186.37, y: 168.42 }) : ''}
        ${ears ? avatars_1.utils.svg.createGroup({ children: ears(baseColor), x: 94, y: 174 }) : ''}
        ${earrings ? avatars_1.utils.svg.createGroup({ children: earrings(earringColor), x: 97, y: 209 }) : ''}
        ${shirt ? avatars_1.utils.svg.createGroup({ children: shirt(shirtColor), x: 63, y: 292 }) : ''}
      `,
        };
    },
};
